
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"39","height":"37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.915 21.111a4.065 4.065 0 004.06-4.06V4.06A4.066 4.066 0 0034.915 0h-4.872a4.03 4.03 0 00-2.436.822v20.29h7.308z","fill":"#0083FF"}}),_c('path',{attrs:{"d":"M0 14.022c0 .976.386 1.885 1.057 2.556a4.032 4.032 0 00-1.04 3.1c.19 2.064 2.05 3.682 4.236 3.682h10.031c-.497 1.508-1.293 4.274-1.293 6.495 0 3.523 2.993 6.496 4.872 6.496 1.688 0 2.893-.95 2.945-.989a.816.816 0 00.303-.635V29.22l4.677-10.131.195-.1V1.584c-1.322-.624-2.995-.96-4.06-.96H7.017c-1.769 0-3.316 1.192-3.68 2.837a3.653 3.653 0 00.294 2.44 3.637 3.637 0 00-1.626 4.873A3.635 3.635 0 000 14.022z","fill":"#0183FE"}})])
          )
        }
      }
    